import { ReactSVG } from "react-svg";
import reporticon from "../../../../assets/images/report-icon.svg";
import refreshicon from "../../../../assets/images/refresh-icon.svg";
import threedotvertical from "../../../../assets/images/three-dots-vertical.svg";
import editicon from "../../../../assets/images/edit-icon.svg";
import deleteicon from "../../../../assets/images/delete-icon.svg";
import { Dropdown, Table } from "react-bootstrap";

import detailicon from "../../../../assets/images/detail-icon.svg";
import { useEffect, useState } from "react";
import useInventory from "../../../../Hooks/useInventory";
import Loading from "../../../../components/LoadingPage/Loading";
import { EditOrderManageDetailModel } from "./popUp/EditOrderMDModel";
import useLocations from "../../../../Hooks/useLocations";
import { itemPagesettingName, toggleClass } from "../../../../utils/commonUtils";
import { selectCurrentUserId } from "../../../../redux/auth/authSlice";
import { useAppSelector } from "../../../../redux/hooks";
import { DeleteConfModel } from "../../../../components/DeleteConfModel/deleteConfModel";
import React from "react";
import useSettings from "../../../../Hooks/useSettings";
export const OrderManagementTab = ({
  toggleOrderMngtDetailModal,
  selectedItem,
  setSelectedOrdManItem,
  invManageData,
  orderMgmtTabErr,
}: any) => {
  const { getLocationsAPI, getLocationsLoading } = useLocations();
  const [locationDropDownVal, setLocationDropDownVal] = useState([]);
  const [showOrderManagementEditModel, SetShowOrderManagementEditModel] = useState(false);
  const [inventoryOrderLevelData, setInventoryOrderLevelData] = useState([]);
  const [requiredDecimalPoint, setRequiredDecimalPoint] = useState<number>(2);
  const [showModal, setShowModal] = useState(false);
  const currentUserId = useAppSelector(selectCurrentUserId);
  const [currentRecord, setCurrentRecord] = useState<any>();
  const { getSettingsAPI, getSettingsLoading } = useSettings();
  const {
    inventoryOrderLevelEditApi,
    inventoryOrderLevelLoadingEdit,
    inventoryOrderLevelDeleteApi,
    inventoryOrderLevelLoadingDelete,
    inventoryOrderManagementGet,
    inventoryOrderManagementLoading
  } = useInventory();

  useEffect(() => {
    getSettings();
  }, []);

  const getOMList = () => {
    inventoryOrderManagementGet(selectedItem.id).then((res: any) => {
      if (res) {
        setInventoryOrderLevelData(res);
      }
    });
  };

  const OMEdit = (values: any) => {
    inventoryOrderLevelEditApi(values)
      .then(() => {
        EditOrderMDModel();
        getOMList();
      })
      .catch();
  };
  const toggleModal = () => {
    toggleClass();
    setShowModal(!showModal);
  };

  const getSettings = async () => {
    try {
      const res = await getSettingsAPI({ searchText: itemPagesettingName });
      if (res) {
        const settingValue = res[0].settingValue ? JSON.parse(res[0].settingValue) : {};
        setRequiredDecimalPoint(settingValue?.RequiredDecimalPoint ?? 2);
      }
    } catch (err: any) {
      console.log("Error while fetching Settings", err);
    }
  }

  useEffect(() => {
    if (selectedItem?.orderingProductMasterId) {
      if (invManageData?.length > 0) getOMList();
      getLocationsAPI({ searchText: "", includeDeleted: false, hasMappedLocation: false })
        .then((res: any) => {
          setLocationDropDownVal(
            res?.map((option: any) => {
              return {
                value: option.id,
                label: option.locationName,
              };
            }),
          );
        })
        .catch();
    }
  }, [selectedItem, invManageData]);

  const deleteOMRecord = () => {
    inventoryOrderLevelDeleteApi(selectedItem.id).then((res: any) => {
      if (res) {
        setInventoryOrderLevelData(res);
      }
    });
  };

  const EditOrderMDModel = () => {
    toggleClass();
    SetShowOrderManagementEditModel(!showOrderManagementEditModel);
  };

  const isLoading = inventoryOrderManagementLoading || getLocationsLoading || inventoryOrderLevelLoadingEdit || inventoryOrderLevelLoadingDelete || getSettingsLoading;

  return (
    <>
      {isLoading ? (<Loading />) : null}
      <div className="inventory-tab-head">
        <h4>
          Displaying {inventoryOrderLevelData?.length || 0} of{" "}
          {inventoryOrderLevelData?.length || 0} Results
        </h4>
        <div className="inventory-tab-action-wrapper">
          {/* <div className="inventory-tab-action-box inventory-tab-action-trans-report">
            <ReactSVG className="svg-box" wrapper="span" src={reporticon} />{" "}
            Order Report
          </div> */}
          {/* <div className="inventory-tab-action-box inventory-tab-action-filter">
            <ReactSVG className="svg-box" wrapper="span" src={filtericon} />
          </div> */}
          <div className="inventory-tab-action-box" onClick={getOMList} title="Refresh" style={{ cursor: "pointer" }}>
            <ReactSVG className="svg-box" wrapper="span" src={refreshicon} />
          </div>

        </div>
      </div>
      <div className="inventory-profile-table-wrapper">
        <Table bordered={false} hover={true}>
          <thead>
            <tr>
              <th>Location</th>
              <th>Reorder Level</th>
              <th>Reorder Quantity</th>
              <th>Quantity On Hand</th>
              <th>Quantity on order</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {orderMgmtTabErr ? (
              <tr>
                <td colSpan={6} className="text-danger text-center k-font-weight-bold py-4">{orderMgmtTabErr}</td>
              </tr>
            ) : (
              <>
                {inventoryOrderLevelData?.map((x: any) => (
                  <tr key={x.locationId}>
                    <td>{x.locationName}</td>
                    <td>{x.reorderLevel || "-"}</td>
                    <td>{x.reorderQty || "-"}</td>
                    <td ref={(el) => {
                      if (el && x?.color) {
                        el.style.setProperty('color', x?.color.toLowerCase(), 'important');
                      }
                    }}>{x.qtyOnHand || "-"}</td>
                    <td>{x.orderQty || "-"}</td>
                    <td>
                      <Dropdown>
                        <Dropdown.Toggle variant="link" id="dropdown-basic">
                          <ReactSVG
                            className="svg-box"
                            wrapper="span"
                            src={threedotvertical}
                          />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => {
                              setCurrentRecord(x);
                              SetShowOrderManagementEditModel(true);
                            }}
                          >
                            <ReactSVG
                              className="svg-box"
                              wrapper="span"
                              src={editicon}
                            />
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => {
                              setCurrentRecord(x);
                              toggleModal();
                            }}
                          >
                            <ReactSVG
                              className="svg-box"
                              wrapper="span"
                              src={deleteicon}
                            />
                            Delete
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => {
                              setSelectedOrdManItem(x);
                              toggleOrderMngtDetailModal();
                            }}
                          >
                            <ReactSVG
                              className="svg-box"
                              wrapper="span"
                              src={detailicon}
                            />
                            Details
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </Table>
      </div>
      {showOrderManagementEditModel && (
        <EditOrderManageDetailModel
          locationDropDownVal={locationDropDownVal}
          currentRecord={currentRecord}
          currentUserId={currentUserId}
          toggleEditOrderMDModel={EditOrderMDModel}
          OMEdit={OMEdit}
          selectedItemName={selectedItem.orderingProductMaster}
          selectedItemId={selectedItem.id}
          requiredDecimalPoint={requiredDecimalPoint}
        />
      )}
      <DeleteConfModel
        showModal={showModal}
        toggleModal={toggleModal}
        deleteAction={deleteOMRecord}
        modelName={`record`}
        recordName={currentRecord?.locationName || ""}
      />
    </>
  );
};
